import type { ToggleCardVariantStyle } from '~/components/Toggle/types'

export type EditorAddOnVariantName = keyof typeof EDITOR_ADD_ON_VARIANTS

export const EDITOR_ADD_ON_VARIANTS = {
  allstar: {
    gradient: {
      bottom: { color: '#5AB0DD33', stop: '100%' },
      top: { color: '#5AB0DD', stop: '0%' },
    },
    illustration: {
      active: 'all-star-active',
      inactive: 'all-star',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  doublePlay: {
    gradient: {
      bottom: { color: '#FF24570A', stop: '86%' },
      top: { color: '#FF245729', stop: '15%' },
    },
    illustration: {
      active: 'double-play-active',
      inactive: 'double-play',
    },
    opacity: { active: 0.6, inactive: 0.2 },
  },
  doubler: {
    gradient: {
      bottom: { color: '#D2A12B33', stop: '102%' },
      top: { color: '#D2A12B', stop: '0%' },
    },
    illustration: {
      active: 'doubler-active',
      inactive: 'doubler',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  extra: {
    gradient: {
      bottom: { color: '#FABF0033', stop: '102%' },
      top: { color: '#FABF00', stop: '0%' },
    },
    illustration: {
      active: 'extra-active',
      inactive: 'extra',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  fireball: {
    gradient: {
      bottom: { color: '#FFD92166', stop: '101%' },
      top: { color: '#FFD921', stop: '0%' },
    },
    illustration: {
      active: 'fireball-active',
      inactive: 'fireball',
    },
    opacity: { active: 0.6, inactive: 0.2 },
  },
  kicker: {
    gradient: {
      bottom: { color: '#00C1DE33', stop: '102%' },
      top: { color: '#00C1DE', stop: '0%' },
    },
    illustration: {
      active: 'kicker-active',
      inactive: 'kicker',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  multiplicador: {
    gradient: {
      bottom: { color: '#FE369E', stop: '102%' },
      top: { color: '#FFA1D2', stop: '0%' },
    },
    illustration: {
      active: 'multiplicador-active',
      inactive: 'multiplicador',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  plus: {
    gradient: {
      bottom: { color: '#10BFFF33', stop: '86%' },
      top: { color: '#10BFFF', stop: '15%' },
    },
    illustration: {
      active: 'plus-active',
      inactive: 'plus',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  powerPlay: {
    gradient: {
      bottom: { color: '#DF353E99', stop: '102%' },
      top: { color: '#DF353E', stop: '0%' },
    },
    illustration: {
      active: 'power-play-active',
      inactive: 'power-play',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  wildball: {
    gradient: {
      bottom: { color: '#ABCE5766', stop: '101%' },
      top: { color: '#7AB762', stop: '0%' },
    },
    illustration: {
      active: 'wild-ball-active',
      inactive: 'wild-ball',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
  xtra: {
    gradient: {
      bottom: { color: '#953C9333', stop: '102%' },
      top: { color: '#953C93', stop: '0%' },
    },
    illustration: {
      active: 'xtra-active',
      inactive: 'xtra',
    },
    opacity: { active: 0.2, inactive: 0.04 },
  },
} as const satisfies Record<string, ToggleCardVariantStyle>

export const EDITOR_PREPAID_SUBSCRIPTION_VARIANT: ToggleCardVariantStyle = {
  gradient: {
    bottom: { color: '#8BF2CB', stop: '101%' },
    top: { color: '#8BF2CB', stop: '0%' },
  },
  illustration: {
    active: 'pre-paid-active',
    inactive: 'pre-paid',
  },
  opacity: { active: 0.4, inactive: 0.2 },
}

export const EDITOR_SUBSCRIPTION_VARIANT: ToggleCardVariantStyle = {
  gradient: {
    bottom: { color: '#8BF2CB', stop: '101%' },
    top: { color: '#8BF2CB33', stop: '0%' },
  },
  illustration: {
    active: 'subscription-active',
    inactive: 'subscription',
  },
  opacity: { active: 0.6, inactive: 0.2 },
}
